export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 3H8V4H16V3H18V4H21V19.5C21 20.3284 20.3284 21 19.5 21H4.5C3.67157 21 3 20.3284 3 19.5V4H6V3ZM16 6V7H18V6H19V9H5V6H6V7H8V6H16ZM19 12H16V14H19V12ZM16 16H19V18H16V16ZM14 12H11V14H14V12Z"
                fill="#7C1D1D"
            />
        </svg>
    );
}
